module.exports = __webpack_public_path__ + "img/pic_2@2x.0405da5d.png";